import { render, staticRenderFns } from "./ArticleSelector.vue?vue&type=template&id=3c44a5b3&"
import script from "./ArticleSelector.vue?vue&type=script&lang=js&"
export * from "./ArticleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports